var _mask, _mask2, _mask3, _mask4, _mask5, _mask6, _mask7, _mask8, _mask9, _mask10, _mask11, _mask12, _mask13, _mask14, _mask15, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _filter10, _filter11, _filter12, _filter13, _filter14, _filter15, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalyMillionday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-50 -50 1020.08 404.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: 79.06,
    y: -8343.44,
    width: 58.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "X",
    x: 79.06,
    y: 179.34,
    width: 58.5,
    height: 34.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.06 179.87c11.95 16.73 24.17 26.87 32.41 32.44a8.3 8.3 0 0 0 12.49-4.25c3.05-9.01 8.2-18.75 13.6-27.64-23.08-1.3-42.4-1.34-58.5-.55Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#c)"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    x: 28.65,
    y: -8343.44,
    width: 39.19,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Y",
    x: 28.65,
    y: 180.99,
    width: 39.19,
    height: 71.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.84 243.94c-2-11.37-3.56-40.23-4.53-62.95-14.58 1.38-25.93 3.46-34.66 5.77 1.56 49.01 14.4 66.08 26.53 66.08 12.93 0 12.66-8.9 12.66-8.9Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#f)"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "h",
    x: 159.46,
    y: -8343.44,
    width: 38.04,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aa",
    x: 159.46,
    y: 181.95,
    width: 38.04,
    height: 69.81,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.03 251.76c16.17 0 6.74-23.72 6.74-23.72-2.36-9.23-2.64-25.38-1.98-42.75a1007.58 1007.58 0 0 0-33.33-3.34c3.1 66.6 14.38 69.8 28.57 69.8Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#i)"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "k",
    x: 205.54,
    y: -8343.44,
    width: 337.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ac",
    x: 205.54,
    y: 186.95,
    width: 337.27,
    height: 64.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.57 248.8c14.36 0 25.3-6.56 33.58-15.22 6.71 14.85 16.01 20.4 24.36 17.37 11.1-4.03 20.98-12.41 26.82-18.12 4.45 9.38 11.55 15.16 22.23 15.16 18.76 0 27.9-9 31.86-14.85 9.31 28.67 38.17 9.96 50.87-.78.14-.13.26-.29.4-.42 7.72 12.3 20.05 20.2 33.96 17.12 19.93-4.42 30.4-16.02 35-29.34 1.33.86 3.37 1.36 6.43 1.25 4.92-.18 8.7-.9 11.74-2 1.85 19.09 7.34 27.68 13.42 30.99 9.17 4.98 20.12-3.77 18.39-14.05-1.05-6.25-1.85-14.3-1.36-21.91-22.8 4.35-46 6.16-71.44 5.91-1.95 4.73-5.52 8.34-11.98 8.34 0 0-6.5.35-10.21-9.04a735.93 735.93 0 0 1-32.35-2.42c-1.5 1.56-3.06 3.14-4.8 4.79-9.92 9.36-12.65 3.79-12.49-6.6a1442.9 1442.9 0 0 1-28.99-3.6c.17 1.87.34 3.75.56 5.73-15.44 18.22-22 8.5-22 8.5-3.55-3.72-5.19-10.16-5.54-18-9.53-1.4-19.46-2.9-29.73-4.48.17 3.92.48 7.7.98 11.28-1.82 2.55-3.18 3.93-3.18 3.93-12.4 17.3-18.05 4.2-18.9-18.5a14343.7 14343.7 0 0 1-32.64-5.18c.5 6.32 1.19 12.26 2.17 17.5-7.3 8.49-20.6 21.87-19.61 5.38.44-7.5 2.3-16.44 3.58-25.07-13.6-2.13-26.46-3.96-38.62-5.52-1.98 26.1.27 61.84 27.5 61.84Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#l)"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "n",
    x: 555.99,
    y: -8343.44,
    width: 60.69,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ae",
    x: 555.99,
    y: 200.98,
    width: 60.69,
    height: 47.91,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.66 247.99c14.83 4.52 31-8.68 43.02-22.26-.03-.18-.1-.32-.1-.52v-22.95c-18.94 19-37.61 33.95-29.99 8.27 1.04-3.5 1.9-6.62 2.65-9.55a344.94 344.94 0 0 1-32.06 9.54c-2.71 14.95-2.13 31.8 16.48 37.47Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#o)"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "q",
    x: 368.72,
    y: -8343.44,
    width: 39.9,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    x: 368.72,
    y: 131.04,
    width: 39.9,
    height: 20.88,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.6 151.92c8.48 0 15.75-5.08 19.02-12.34-20.8 8.11-34-1.96-39.9-8.54a20.88 20.88 0 0 0 20.88 20.88Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#r)"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "t",
    x: 208.79,
    y: -8343.44,
    width: 39.9,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ah",
    x: 208.79,
    y: 131.04,
    width: 39.9,
    height: 20.88,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.67 151.92c8.49 0 15.75-5.08 19.02-12.34-20.8 8.11-34-1.96-39.9-8.54a20.88 20.88 0 0 0 20.88 20.88Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#u)"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "w",
    x: 178.48,
    y: -8343.44,
    width: 7.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aj",
    x: 178.48,
    y: 117.65,
    width: 7.28,
    height: 7.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.76 121.28a3.64 3.64 0 1 1-7.28 0 3.64 3.64 0 0 1 7.28 0Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#x)"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "z",
    x: 230.64,
    y: -8343.44,
    width: 15.33,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ak",
    x: 230.64,
    y: 122.92,
    width: 15.33,
    height: 15.33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#z)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 130.58,
    r: 7.67,
    transform: "rotate(-45 238.3 130.58)",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#A)"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "C",
    x: 174.45,
    y: -8343.44,
    width: 15.33,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "al",
    x: 174.45,
    y: 113.62,
    width: 15.33,
    height: 15.33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#C)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.12,
    cy: 121.28,
    r: 7.67,
    transform: "rotate(-81.14 182.12 121.28)",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#D)"
  })))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "F",
    x: 391.17,
    y: -8343.44,
    width: 15.33,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "an",
    x: 391.17,
    y: 124.92,
    width: 15.33,
    height: 15.33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#F)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 398.83,
    cy: 132.59,
    r: 7.67,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#G)"
  })))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "I",
    x: 569.83,
    y: -8343.44,
    width: 15.33,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ap",
    x: 569.83,
    y: 170.61,
    width: 15.33,
    height: 15.33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#H)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 577.5,
    cy: 178.28,
    r: 7.67,
    transform: "rotate(-45 577.5 178.28)",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#J)"
  })))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "L",
    x: 475.04,
    y: -8343.44,
    width: 15.33,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ar",
    x: 475.04,
    y: 190.82,
    width: 15.33,
    height: 15.33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#K)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#L)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 482.71,
    cy: 198.49,
    r: 7.67,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#M)"
  })))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "O",
    x: 477.2,
    y: -8343.44,
    width: 7.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "at",
    x: 477.2,
    y: 194.85,
    width: 7.28,
    height: 7.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#N)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#O)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 480.84,
    cy: 198.49,
    r: 3.64,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#P)"
  })))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "R",
    x: 575.43,
    y: -8343.44,
    width: 7.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "av",
    x: 575.43,
    y: 174.64,
    width: 7.28,
    height: 7.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Q)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.7 178.28a3.64 3.64 0 1 1-7.27 0 3.64 3.64 0 0 1 7.27 0Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#S)"
  })))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 182.12,
    cy: 121.28,
    fx: 182.12,
    fy: 121.28,
    r: 3.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "U",
    cx: 182.12,
    cy: 121.28,
    fx: 182.12,
    fy: 121.28,
    r: 3.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 238.31,
    cy: 130.58,
    fx: 238.31,
    fy: 130.58,
    r: 7.67,
    gradientTransform: "rotate(45 238.3 130.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "T",
    cx: 238.31,
    cy: 130.58,
    fx: 238.31,
    fy: 130.58,
    r: 7.67,
    gradientTransform: "rotate(45 238.3 130.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 182.12,
    cy: 121.28,
    fx: 182.12,
    fy: 121.28,
    r: 7.67,
    gradientTransform: "rotate(81.14 182.12 121.28)",
    xlinkHref: "#A"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "am",
    cx: 182.12,
    cy: 121.28,
    fx: 182.12,
    fy: 121.28,
    r: 7.67,
    gradientTransform: "rotate(81.14 182.12 121.28)",
    xlinkHref: "#T"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 398.83,
    cy: 132.59,
    fx: 398.83,
    fy: 132.59,
    r: 7.67,
    xlinkHref: "#A"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ao",
    cx: 398.83,
    cy: 132.59,
    fx: 398.83,
    fy: 132.59,
    r: 7.67,
    xlinkHref: "#T"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 577.5,
    cy: 178.28,
    fx: 577.5,
    fy: 178.28,
    r: 7.67,
    gradientTransform: "rotate(45 577.5 178.28)",
    xlinkHref: "#A"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aq",
    cx: 577.5,
    cy: 178.28,
    fx: 577.5,
    fy: 178.28,
    r: 7.67,
    gradientTransform: "rotate(45 577.5 178.28)",
    xlinkHref: "#T"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "M",
    cx: 482.71,
    cy: 198.49,
    fx: 482.71,
    fy: 198.49,
    r: 7.67,
    xlinkHref: "#A"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "as",
    cx: 482.71,
    cy: 198.49,
    fx: 482.71,
    fy: 198.49,
    r: 7.67,
    xlinkHref: "#T"
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "P",
    cx: 480.84,
    cy: 198.49,
    fx: 480.84,
    fy: 198.49,
    r: 3.64,
    xlinkHref: "#x"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "au",
    cx: 480.84,
    cy: 198.49,
    fx: 480.84,
    fy: 198.49,
    r: 3.64,
    xlinkHref: "#U"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "S",
    cx: 579.07,
    cy: 178.28,
    fx: 579.07,
    fy: 178.28,
    r: 3.64,
    xlinkHref: "#x"
  })), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aw",
    cx: 579.07,
    cy: 178.28,
    fx: 579.07,
    fy: 178.28,
    r: 3.64,
    xlinkHref: "#U"
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 79.06,
    y: 179.34,
    width: 40,
    height: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 28.65,
    y: 180.99,
    width: 39.19,
    height: 71.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 159.46,
    y: 181.95,
    width: 38.04,
    height: 69.81,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 205.54,
    y: 186.95,
    width: 337.27,
    height: 64.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 555.99,
    y: 200.98,
    width: 60.69,
    height: 47.91,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 368.72,
    y: 131.04,
    width: 39.9,
    height: 20.88,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 208.79,
    y: 131.04,
    width: 39.9,
    height: 20.88,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "v",
    x: 178.48,
    y: 117.65,
    width: 7.28,
    height: 7.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "y",
    x: 230.64,
    y: 122.92,
    width: 15.33,
    height: 15.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    id: "B",
    x: 174.45,
    y: 113.62,
    width: 15.33,
    height: 15.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter11 || (_filter11 = /*#__PURE__*/React.createElement("filter", {
    id: "E",
    x: 391.17,
    y: 124.92,
    width: 15.33,
    height: 15.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter12 || (_filter12 = /*#__PURE__*/React.createElement("filter", {
    id: "H",
    x: 569.83,
    y: 170.61,
    width: 15.33,
    height: 15.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter13 || (_filter13 = /*#__PURE__*/React.createElement("filter", {
    id: "K",
    x: 475.04,
    y: 190.82,
    width: 15.33,
    height: 15.33,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter14 || (_filter14 = /*#__PURE__*/React.createElement("filter", {
    id: "N",
    x: 477.2,
    y: 194.85,
    width: 7.28,
    height: 7.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _filter15 || (_filter15 = /*#__PURE__*/React.createElement("filter", {
    id: "Q",
    x: 575.43,
    y: 174.64,
    width: 7.28,
    height: 7.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 108.31,
    y1: 252.84,
    x2: 108.31,
    y2: 170.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 108.31,
    y1: 252.84,
    x2: 108.31,
    y2: 170.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fde4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fbcea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f9bb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8ab69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f79d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f6933f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f68c32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f6882b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f68729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f68729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f68729"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 48.25,
    y1: 252.84,
    x2: 48.25,
    y2: 170.5,
    xlinkHref: "#c"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 48.25,
    y1: 252.84,
    x2: 48.25,
    y2: 170.5,
    xlinkHref: "#V"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 178.48,
    y1: 252.84,
    x2: 178.48,
    y2: 170.5,
    xlinkHref: "#c"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 178.48,
    y1: 252.84,
    x2: 178.48,
    y2: 170.5,
    xlinkHref: "#V"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 374.17,
    y1: 252.84,
    x2: 374.17,
    y2: 170.5,
    xlinkHref: "#c"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 374.17,
    y1: 252.84,
    x2: 374.17,
    y2: 170.5,
    xlinkHref: "#V"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 586.33,
    y1: 252.84,
    x2: 586.33,
    y2: 170.5,
    xlinkHref: "#c"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 586.33,
    y1: 252.84,
    x2: 586.33,
    y2: 170.5,
    xlinkHref: "#V"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 388.67,
    y1: 151.92,
    x2: 388.67,
    y2: 131.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 388.67,
    y1: 151.92,
    x2: 388.67,
    y2: 131.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fde4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fbcea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f9bb86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f8ab69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f79d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f6933f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f68c32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f6882b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f68729"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 228.74,
    x2: 228.74,
    xlinkHref: "#r"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 228.74,
    x2: 228.74,
    xlinkHref: "#W"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M569.96 260.1c-7.68-2.34-13.27-5.97-17.28-10.38a26.38 26.38 0 0 1-3.4 5.11 25.56 25.56 0 0 1-19.47 9.23c-4.02 0-8.04-1.03-11.62-2.98-7.92-4.3-16.32-12.25-20.24-23.8-6.8 10.13-18.25 19.87-37.56 24.15-2.9.64-5.85.97-8.76.97-11.02 0-21.49-4.6-30.01-12.92-8.71 5.85-20.08 11.54-31.36 11.54-8.02 0-15.02-2.86-20.47-8.14-6.9 4.35-16.4 7.77-29.23 7.77-9.47 0-17.76-3.23-24.3-9.3-5.9 4.47-12.86 8.76-20.43 11.5a25.67 25.67 0 0 1-8.78 1.56c-5.5 0-14.58-1.82-23.02-11.85a55.35 55.35 0 0 1-30.46 8.9c-9.93 0-18.6-3.48-25.26-10.01a21.02 21.02 0 0 1-2.09 3.96c-3.94 5.81-10.4 9.02-18.19 9.02-26.64 0-37.6-17.87-40.91-75.38-4.52 7.6-8.67 15.68-11.17 23.07a20.99 20.99 0 0 1-31.58 10.68c-6.85-4.63-16.98-12.68-27.6-25.26.95 18.49 2.17 36.4 3.55 44.21l.15.9.03.91c.06 1.96-.2 8.8-5.91 14.7-3.21 3.3-9.18 7.24-19.41 7.24-14.7 0-39.35-11.55-39.35-88.93 0-60.76 4.34-91.62 28.03-91.62h.65c14.9 0 30.37 2.65 41.48 34.35 4.32 12.32 13.04 24.83 20.26 33.84 8.38-12.84 23.84-32.66 52.29-61.46 5.54-5.61 17.19-5.9 19.46-5.9 12.19 0 22.24 5.14 28.7 14.21 4.14-3.04 11.9-6.67 25.39-6.67 10.08 0 17.2 2.04 22.2 4.33.69-3.4 1.32-6.77 2.1-10.25 1.67-12.15 9.59-31.83 29.33-31.83 4.22 0 8.62 1 13.08 2.98 1.47.65 2.87 1.25 4.2 1.8 8.4 3.59 17.1 7.29 20.93 16.9 2.03 5.1 2.2 10.66.9 17.24A21.54 21.54 0 0 1 336 91.43c5.37 0 10.92 1.9 16.49 5.65 1.42.96 2.76 1.84 4 2.66 1.38.91 2.86 1.9 4.34 2.95a38.2 38.2 0 0 1 25.77-10 38.4 38.4 0 0 1 38.4 38.4c0 5.77-1.3 11.22-3.6 16.12 2.32.93 4.46 2.15 6.52 3.49a38.19 38.19 0 0 1 25.58-5.96c2.49.22 4.73.71 6.73 1.4l.22.08c.41.14.83.28 1.22.44.87.31 1.73.62 2.57.99 2.18-.53 4.67-.91 7.38-.91 6.17 0 17.01 2.07 25.52 14.42 1.65-12.99 13.75-23.12 28.6-23.12 8.35 0 15.8 3.24 21.09 8.33 1.15.74 2.34 1.43 3.39 2.29 5.08-3.15 11.45-4.93 18.29-4.93 9.06 0 17.43 3.21 23.58 9.05 11.91 11.32 16.1 21.06 10.91 45.07 3.5-3.4 7.78-7.74 12.76-12.96V157.8c-2.95-5.75-7.12-11.14-12.78-16.52-9.1-8.63-21.35-13.39-34.48-13.39-5.65 0-11.13.85-16.25 2.51a46.24 46.24 0 0 0-26.52-8.2c-13.1 0-25 5.35-33.22 13.95a44.25 44.25 0 0 0-26.8-4.87l-.37-.13a43.69 43.69 0 0 0-10.22-2.17 53.76 53.76 0 0 0-14.33.22 54.3 54.3 0 0 0-54.2-52.34c-9.14 0-18.03 2.3-25.94 6.63-6.7-4.38-13.59-6.96-20.54-7.69-.4-1.5-.9-2.97-1.47-4.42-6.27-15.74-19.67-21.44-29.45-25.6-1.32-.56-2.62-1.11-3.98-1.72a48.03 48.03 0 0 0-19.49-4.33c-23.94 0-38.57 18.28-43.63 38.34-3.22-.4-6.55-.6-10-.6-8.98 0-16.22 1.36-21.96 3.27-8.8-7.04-19.83-10.8-32.13-10.8-6.09 0-21.27 1.03-30.73 10.6-16.46 16.67-30.09 31.83-40.75 45.31a70.88 70.88 0 0 1-5.59-11.8c-13.88-39.6-36.3-44.94-56.42-44.94h-.65C0 69.12 0 128.7 0 176.57c0 91.15 34.57 104.76 55.18 104.76 15.76 0 25.43-6.55 30.77-12.05a36.37 36.37 0 0 0 10.38-26.2l-.03-.91-.04-1.14-.2-1.12-.15-.9c-.13-.72-.28-1.72-.46-3.13l.05.04a36.78 36.78 0 0 0 41.74-.39c6.53 25.41 20.2 44.73 50.79 44.73 8.87 0 17-2.7 23.46-7.65a52.59 52.59 0 0 0 22.08 4.68c9.82 0 19.17-1.86 27.93-5.55a43.66 43.66 0 0 0 25.56 8.5c4.82 0 9.58-.84 14.16-2.5 4.96-1.8 9.94-4.2 14.91-7.19a51.55 51.55 0 0 0 24.43 5.93c10.09 0 19.4-1.72 27.78-5.13a44.99 44.99 0 0 0 21.92 5.5c9.56 0 19.63-2.75 30.06-8.18a57.12 57.12 0 0 0 31.31 9.56c4.06 0 8.16-.45 12.19-1.34 11.97-2.66 22.54-7.41 31.35-14.03A59.59 59.59 0 0 0 510.63 275a40.3 40.3 0 0 0 19.18 4.9 41 41 0 0 0 25.28-8.78 61.2 61.2 0 0 0 10.26 4.14 49.53 49.53 0 0 0 14.45 2.14c14.25 0 27.38-6.12 38.8-14.59v-20.6c-11.1 10.59-24.58 19.36-38.8 19.36-3.36 0-6.67-.5-9.84-1.46Z",
    style: {
      fill: "#26c2e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 197.74c5.19-24.01 1-33.75-10.92-45.07-6.15-5.84-14.52-9.05-23.58-9.05-6.84 0-13.21 1.78-18.3 4.93-1.04-.86-2.23-1.55-3.38-2.29a30.29 30.29 0 0 0-21.09-8.33c-14.85 0-26.95 10.13-28.6 23.12-8.5-12.35-19.35-14.42-25.52-14.42-2.71 0-5.2.38-7.38.9-.84-.36-1.7-.67-2.57-.98-.39-.16-.8-.3-1.22-.45l-.22-.07c-2-.69-4.24-1.18-6.73-1.4a38.19 38.19 0 0 0-25.58 5.96 37.74 37.74 0 0 0-6.51-3.49 38.03 38.03 0 0 0 3.59-16.12 38.4 38.4 0 0 0-38.4-38.4 38.2 38.2 0 0 0-25.77 10 172.6 172.6 0 0 0-4.34-2.95c-1.24-.82-2.58-1.7-4-2.66-5.57-3.75-11.12-5.65-16.5-5.65-4.24 0-8 1.17-11.15 3.06 1.3-6.58 1.13-12.14-.9-17.24-3.83-9.61-12.53-13.31-20.94-16.9-1.32-.55-2.72-1.15-4.2-1.8a32.33 32.33 0 0 0-13.07-2.98c-19.74 0-27.66 19.68-29.33 31.83-.78 3.48-1.41 6.84-2.1 10.25-5-2.3-12.12-4.33-22.2-4.33-13.5 0-21.25 3.63-25.4 6.67-6.45-9.07-16.5-14.21-28.69-14.21-2.27 0-13.92.28-19.46 5.9-28.45 28.8-43.9 48.62-52.3 61.46-7.2-9-15.93-21.53-20.25-33.84-11.1-31.7-26.58-34.35-41.48-34.35h-.65c-23.7 0-28.03 30.86-28.03 91.62 0 77.38 24.65 88.93 39.35 88.93 10.23 0 16.2-3.94 19.4-7.25a20.7 20.7 0 0 0 5.92-14.69l-.03-.91-.15-.9c-1.38-7.8-2.6-25.72-3.55-44.21 10.62 12.58 20.75 20.63 27.6 25.26a20.99 20.99 0 0 0 31.58-10.68c2.5-7.39 6.65-15.47 11.17-23.07 3.31 57.5 14.27 75.37 40.91 75.37 7.79 0 14.25-3.2 18.2-9 .85-1.27 1.52-2.6 2.08-3.97 6.67 6.53 15.33 10 25.26 10a55.35 55.35 0 0 0 30.46-8.9c8.44 10.03 17.53 11.86 23.02 11.86 2.98 0 5.93-.52 8.78-1.55 7.57-2.75 14.53-7.04 20.43-11.51 6.54 6.07 14.83 9.3 24.3 9.3 12.82 0 22.33-3.42 29.23-7.78 5.45 5.3 12.45 8.14 20.47 8.14 11.28 0 22.65-5.68 31.36-11.53 8.52 8.33 19 12.92 30.01 12.92 2.91 0 5.86-.33 8.76-.97 19.31-4.28 30.75-14.02 37.56-24.15 3.92 11.55 12.32 19.5 20.24 23.8a24.41 24.41 0 0 0 11.62 2.98c7.41 0 14.51-3.36 19.47-9.23a26.37 26.37 0 0 0 3.4-5.11c4 4.41 9.6 8.04 17.28 10.38 3.17.97 6.48 1.46 9.84 1.46 14 0 27.26-8.5 38.25-18.87l-2.29-84.88v27.08A476.49 476.49 0 0 1 603 197.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.66 247.99c14.83 4.52 31-8.68 43.02-22.26-.03-.18-.1-.32-.1-.52v-22.95c-18.94 19-37.61 33.95-29.99 8.27 1.04-3.5 1.9-6.62 2.65-9.55a344.94 344.94 0 0 1-32.06 9.54c-2.71 14.95-2.13 31.8 16.48 37.47Z",
    style: {
      fill: "#fec128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.33 193.97c-4.62 4.48-6.55 12.02-7.06 20.03a317.81 317.81 0 0 0 15.9-3.48c1.42-7.77 3.7-15.04 4.83-19.93 0 0-.47-9.4-13.67 3.38Zm-77.14 3.35c-8.9-4.85-14.56-20-14.56-20s-11.52-.81-11.52 25.46c0 7.47 1.05 12.7 2.53 16.43 7.6.4 14.99.63 22.2.7 3.77-9.16 1.35-22.59 1.35-22.59Zm-333.63-16.9c6.97.4 14.22.89 21.9 1.53-.43-9.29-.7-19.79-.8-31.7 0 0-11 13.58-21.1 30.17Zm-74.25.57a353.9 353.9 0 0 1 15.75-1.12 171.4 171.4 0 0 1-16.88-29.62s.4 13.62 1.13 30.74Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18 150.25a171.4 171.4 0 0 0 16.88 29.62c16.1-.8 35.42-.75 58.5.55 10.1-16.6 21.1-30.17 21.1-30.17.1 11.91.37 22.4.8 31.7 10.44.87 21.52 1.96 33.33 3.34 1.3-34.31 6.29-73.4 6.29-73.4-8.09-18.86-30-12.86-31.53-11.31-53.76 54.44-58.75 74.65-58.75 74.65s-25.6-25.6-34.76-51.74c-9.16-26.14-19.4-25.87-30.18-25.87s-15.36 22.1-15.36 78.95c0 3.54.05 6.93.15 10.19 8.73-2.3 20.08-4.4 34.66-5.77-.73-17.12-1.13-30.74-1.13-30.74Z",
    style: {
      fill: "#fec128"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.6,
    cy: 131.03,
    r: 20.88,
    style: {
      fill: "#fec128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.18 115.14c16.17-37.17 8.55-36.56-10.51-45.01-21.3-9.43-24.8 19.47-24.8 19.47-10 44.66-12.34 79.32-10.31 105.06 11.27 1.8 22.17 3.54 32.63 5.18-.99-26.08 4.34-64.82 12.99-84.7Zm55.51 13.46c5.66-9.16-.27-11.58-14.28-21.01-14.02-9.43-18.6 3.23-18.6 3.23-2.83 4.16-8.08 16.98-12.93 57.67-1.44 12.05-2.07 23.9-1.58 34.64 10.27 1.58 20.2 3.08 29.73 4.48-1.21-27.35 13.26-71.88 17.66-79Zm85.42 74.18c0-26.27 11.52-25.46 11.52-25.46s5.66 15.15 14.56 20c0 0 2.42 13.43-1.36 22.6 25.44.24 48.64-1.57 71.44-5.92.5-8.01 2.44-15.55 7.06-20.03 13.2-12.78 13.67-3.38 13.67-3.38-1.13 4.89-3.41 12.16-4.82 19.93 10.6-2.59 21.23-5.75 32.06-9.54 6.68-25.95 2.6-30.97-5.88-39.02-9.43-8.95-26.14-6.14-30.72 1.61-4.58 7.75-9.7 7.34-9.7 7.34 2.7-5.65 7-10.03-9.7-17.58-16.71-7.54-21.02 17.58-21.02 17.58a310.83 310.83 0 0 0-2.02 30.55c-4.08 3.98-9.13 6.26-14.68 2.77.55-11.98-2.3-23.74-6.35-31.77-10.5-20.81-27.08-10.5-27.08-10.5s-14.15-16.98-37.8 13.54c-8.85 11.43-10.52 26.25-7.43 39.66l-1.57 1.63a735.93 735.93 0 0 0 32.35 2.42c-1.48-3.73-2.53-8.96-2.53-16.43ZM229 158.52a24.46 24.46 0 0 0-22.33 21.74c-.23 2.12-.42 4.38-.6 6.69 12.17 1.56 25.02 3.39 38.63 5.52 2.6-17.43 2.86-33.6-15.7-33.95Zm174.61 15.9c2.16-16.71-15.9-14.43-15.9-14.43-16.13 1.1-21.8 16.39-18.7 51.4a1442.9 1442.9 0 0 0 28.99 3.59c.18-12.34 4.44-31.49 5.61-40.56Zm-324.55 5.45c11.95 16.73 24.17 26.87 32.41 32.44a8.3 8.3 0 0 0 12.49-4.25c3.05-9.01 8.2-18.75 13.6-27.64-23.08-1.3-42.4-1.34-58.5-.55Zm-11.22 64.07c-2-11.37-3.56-40.23-4.53-62.95-14.58 1.38-25.93 3.46-34.66 5.77 1.56 49.01 14.4 66.08 26.53 66.08 12.93 0 12.66-8.9 12.66-8.9Zm120.19 7.82c16.17 0 6.74-23.72 6.74-23.72-2.36-9.23-2.64-25.38-1.98-42.75a1007.58 1007.58 0 0 0-33.33-3.34c3.1 66.6 14.38 69.8 28.57 69.8Z",
    style: {
      fill: "#fec128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.57 248.8c14.36 0 25.3-6.56 33.58-15.22 6.71 14.85 16.01 20.4 24.36 17.37 11.1-4.03 20.98-12.41 26.82-18.12 4.45 9.38 11.55 15.16 22.23 15.16 18.76 0 27.9-9 31.86-14.85 9.31 28.67 38.17 9.96 50.87-.78.14-.13.26-.29.4-.42 7.72 12.3 20.05 20.2 33.96 17.12 19.93-4.42 30.4-16.02 35-29.34 1.33.86 3.37 1.36 6.43 1.25 4.92-.18 8.7-.9 11.74-2 1.85 19.09 7.34 27.68 13.42 30.99 9.17 4.98 20.12-3.77 18.39-14.05-1.05-6.25-1.85-14.3-1.36-21.91-22.8 4.35-46 6.16-71.44 5.91-1.95 4.73-5.52 8.34-11.98 8.34 0 0-6.5.35-10.21-9.04a735.93 735.93 0 0 1-32.35-2.42c-1.5 1.56-3.06 3.14-4.8 4.79-9.92 9.36-12.65 3.79-12.49-6.6a1442.9 1442.9 0 0 1-28.99-3.6c.17 1.87.34 3.75.56 5.73-15.44 18.22-22 8.5-22 8.5-3.55-3.72-5.19-10.16-5.54-18-9.53-1.4-19.46-2.9-29.73-4.48.17 3.92.48 7.7.98 11.28-1.82 2.55-3.18 3.93-3.18 3.93-12.4 17.3-18.05 4.2-18.9-18.5a14343.7 14343.7 0 0 1-32.64-5.18c.5 6.32 1.19 12.26 2.17 17.5-7.3 8.49-20.6 21.87-19.61 5.38.44-7.5 2.3-16.44 3.58-25.07-13.6-2.13-26.46-3.96-38.62-5.52-1.98 26.1.27 61.84 27.5 61.84Z",
    style: {
      fill: "#fec128"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.06 179.87c11.95 16.73 24.17 26.87 32.41 32.44a8.3 8.3 0 0 0 12.49-4.25c3.05-9.01 8.2-18.75 13.6-27.64-23.08-1.3-42.4-1.34-58.5-.55Z",
    fill: "url(#V)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.84 243.94c-2-11.37-3.56-40.23-4.53-62.95-14.58 1.38-25.93 3.46-34.66 5.77 1.56 49.01 14.4 66.08 26.53 66.08 12.93 0 12.66-8.9 12.66-8.9Z",
    fill: "url(#Z)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.03 251.76c16.17 0 6.74-23.72 6.74-23.72-2.36-9.23-2.64-25.38-1.98-42.75a1007.58 1007.58 0 0 0-33.33-3.34c3.1 66.6 14.38 69.8 28.57 69.8Z",
    fill: "url(#ab)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.57 248.8c14.36 0 25.3-6.56 33.58-15.22 6.71 14.85 16.01 20.4 24.36 17.37 11.1-4.03 20.98-12.41 26.82-18.12 4.45 9.38 11.55 15.16 22.23 15.16 18.76 0 27.9-9 31.86-14.85 9.31 28.67 38.17 9.96 50.87-.78.14-.13.26-.29.4-.42 7.72 12.3 20.05 20.2 33.96 17.12 19.93-4.42 30.4-16.02 35-29.34 1.33.86 3.37 1.36 6.43 1.25 4.92-.18 8.7-.9 11.74-2 1.85 19.09 7.34 27.68 13.42 30.99 9.17 4.98 20.12-3.77 18.39-14.05-1.05-6.25-1.85-14.3-1.36-21.91-22.8 4.35-46 6.16-71.44 5.91-1.95 4.73-5.52 8.34-11.98 8.34 0 0-6.5.35-10.21-9.04a735.93 735.93 0 0 1-32.35-2.42c-1.5 1.56-3.06 3.14-4.8 4.79-9.92 9.36-12.65 3.79-12.49-6.6a1442.9 1442.9 0 0 1-28.99-3.6c.17 1.87.34 3.75.56 5.73-15.44 18.22-22 8.5-22 8.5-3.55-3.72-5.19-10.16-5.54-18-9.53-1.4-19.46-2.9-29.73-4.48.17 3.92.48 7.7.98 11.28-1.82 2.55-3.18 3.93-3.18 3.93-12.4 17.3-18.05 4.2-18.9-18.5a14343.7 14343.7 0 0 1-32.64-5.18c.5 6.32 1.19 12.26 2.17 17.5-7.3 8.49-20.6 21.87-19.61 5.38.44-7.5 2.3-16.44 3.58-25.07-13.6-2.13-26.46-3.96-38.62-5.52-1.98 26.1.27 61.84 27.5 61.84Z",
    fill: "url(#ad)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.66 247.99c14.83 4.52 31-8.68 43.02-22.26-.03-.18-.1-.32-.1-.52v-22.95c-18.94 19-37.61 33.95-29.99 8.27 1.04-3.5 1.9-6.62 2.65-9.55a344.94 344.94 0 0 1-32.06 9.54c-2.71 14.95-2.13 31.8 16.48 37.47Z",
    fill: "url(#af)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.6 151.92c8.48 0 15.75-5.08 19.02-12.34-20.8 8.11-34-1.96-39.9-8.54a20.88 20.88 0 0 0 20.88 20.88Z",
    fill: "url(#W)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 229.67,
    cy: 131.03,
    r: 20.88,
    transform: "rotate(-62.54 229.67 131.03)",
    style: {
      fill: "#fec128"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.67 151.92c8.49 0 15.75-5.08 19.02-12.34-20.8 8.11-34-1.96-39.9-8.54a20.88 20.88 0 0 0 20.88 20.88Z",
    fill: "url(#ai)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.76 121.28a3.64 3.64 0 1 1-7.28 0 3.64 3.64 0 0 1 7.28 0Z",
    fill: "url(#U)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ak)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 130.58,
    r: 7.67,
    transform: "rotate(-45 238.3 130.58)",
    fill: "url(#T)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#al)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.12,
    cy: 121.28,
    r: 7.67,
    transform: "rotate(-81.14 182.12 121.28)",
    fill: "url(#am)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#an)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 398.83,
    cy: 132.59,
    r: 7.67,
    fill: "url(#ao)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ap)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 577.5,
    cy: 178.28,
    r: 7.67,
    transform: "rotate(-45 577.5 178.28)",
    fill: "url(#aq)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ar)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 482.71,
    cy: 198.49,
    r: 7.67,
    fill: "url(#as)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#at)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 480.84,
    cy: 198.49,
    r: 3.64,
    fill: "url(#au)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.7 178.28a3.64 3.64 0 1 1-7.27 0 3.64 3.64 0 0 1 7.27 0Z",
    fill: "url(#aw)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M661.6 107.79a3.1 3.1 0 0 0-.61-1.27l-60.64-73.37a3.16 3.16 0 1 0-4.88 4.03l59.88 72.46c1.93-.81 4-1.44 6.25-1.85Zm33.12-19.94c-1.28 0-2.49-.78-2.96-2.06l-21.84-58.82a3.17 3.17 0 0 1 5.94-2.2l21.83 58.82a3.17 3.17 0 0 1-2.97 4.26Zm42.24 13.68c.22 0 .44-.04.66-.04l1.5-72.32a3.17 3.17 0 0 0-3.1-3.23h-.07a3.17 3.17 0 0 0-3.17 3.1l-1.51 73.03c1.9-.37 3.81-.57 5.7-.54ZM779.8 83a3.17 3.17 0 0 1-2.97-4.27l22.65-61.03a3.17 3.17 0 0 1 5.93 2.2l-22.63 61.03A3.17 3.17 0 0 1 779.8 83Zm52.15 9.03c.45 0 .87.05 1.3.06l13.4-18.37a3.18 3.18 0 0 0-5.13-3.74l-16.56 22.73c2.18-.44 4.5-.68 7-.68Zm82.29 1.69a4.48 4.48 0 0 0-6.15-1.59l-44.87 26.48a4.47 4.47 0 0 0-2.07 2.79 9.77 9.77 0 0 1 3.14-.54 8.65 8.65 0 0 1 7.15 3.34l41.22-24.32a4.5 4.5 0 0 0 1.58-6.16ZM597.9 116.15a3.1 3.1 0 0 1-1.52-.4L563.64 97.7a3.16 3.16 0 1 1 3.06-5.54l32.74 18.05a3.16 3.16 0 0 1-1.53 5.94Z",
    style: {
      fill: "#fff200"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.46,
    cy: 14.08,
    r: 7.48,
    style: {
      fill: "#26c2e4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 735.95,
    cy: 7.48,
    r: 7.48,
    style: {
      fill: "#26c2e4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.76,
    cy: 52.55,
    r: 7.48,
    transform: "rotate(-22.61 861.76 52.55)",
    style: {
      fill: "#26c2e4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942.6,
    cy: 168.56,
    r: 7.48,
    style: {
      fill: "#26c2e4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 924.82,
    cy: 243.34,
    r: 7.48,
    style: {
      fill: "#26c2e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.11 186.28a3.17 3.17 0 0 1-.52-6.3l61.04-10.3a3.17 3.17 0 0 1 1.06 6.24l-61.04 10.31c-.18.03-.36.05-.54.05Zm40.64 56.39c-.17 0-.34-.02-.51-.05L865 235.75a3.16 3.16 0 1 1 1.01-6.24l42.24 6.87a3.16 3.16 0 0 1-.5 6.29Z",
    style: {
      fill: "#fff200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.65 227.09a2.39 2.39 0 0 1 3-2.68c.34.1 35.9 9.62 65.73-13.4l3.23-83.87-230.47 16.1 3.54 125.83a8.22 8.22 0 0 0 7.97 7.98l120.87 3.54c4.58-1.21 33.29-10.6 26.13-53.5Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M761.96 280.5c61.79-3.44 78.33-46.73 82.36-62.8-25.4 17.23-52.85 13.96-62.46 12.1 3.85 29.93-9.53 44.23-19.9 50.7Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m785.54 281.62 48.92 1.43h.24c4.4 0 8.04-3.47 8.21-7.9l1.7-44.19c-7.3 17.17-23.65 41.38-59.07 50.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.52 103.47a8.22 8.22 0 0 0-8.95-8.5L625.04 114.6a8.22 8.22 0 0 0-7.47 8.42l.57 20.22 230.47-16.1.91-23.67Z",
    style: {
      fill: "#ee312c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.46 131.42c-1.3-.18-2.43.94-2.5 2.25l-8.54 160.26c-.12 3.19-2.94 5.52-6 5.61l-147.13-4.3c-1.22.08-2.4.99-2.44 2.3-.04 1.31 1 2.4 2.3 2.44l147.13 4.31.3.01c5.65 0 10.37-4.5 10.59-10.15l8.53-160.24a2.37 2.37 0 0 0-2.24-2.49Z",
    style: {
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: ".025px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.39 168.36c5.8 0 10.53 4.74 10.53 10.56v49.54a11.9 11.9 0 0 1-11.64 11.96l-8.92.25v-71.51l9.12-.76c.3-.03.6-.04.91-.04m0-13.93c-.69 0-1.38.03-2.07.08l-17.7 1.48a4.57 4.57 0 0 0-4.2 4.56v89.75a4.57 4.57 0 0 0 4.7 4.57l18.55-.52a25.9 25.9 0 0 0 25.18-25.9v-49.53a24.5 24.5 0 0 0-24.46-24.5Zm32.35 22.79v71.67c0 3.3 2.68 5.98 5.99 5.98h.54c3.69 0 6.68-3 6.68-6.69v-39.23l20.08-1.41v41.35c0 3.3 2.67 5.98 5.98 5.98 3.69 0 6.68-3 6.68-6.69v-77.5a19.7 19.7 0 0 0-19.7-19.7 26.24 26.24 0 0 0-26.25 26.24Zm13.2 18.91v-20.6a9.8 9.8 0 0 1 9.81-9.8c5.68 0 10.28 4.6 10.28 10.27v18.72l-20.08 1.41ZM803 145.72h-.54c-3.7 0-6.68 3-6.68 6.69v29.4a9.8 9.8 0 0 1-9.8 9.81c-5.68 0-10.28-4.6-10.28-10.27v-26.3c0-3.3-2.68-5.99-5.98-5.99-3.7 0-6.69 3-6.69 6.69v30.92c0 10 7.48 18.17 17.14 19.44v20.64c.66-.48 1.5-.72 2.5-.54 3.02.54 5.95 1.57 9 1.9.44.05.82.2 1.16.37v-24.13a26.24 26.24 0 0 0 16.15-24.22V151.7c0-3.3-2.68-5.98-5.98-5.98Z",
    style: {
      fill: "#ee312c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.38 285.43c1.2.03 2.37.04 3.54.04l.43-.01 79.97 2.34h.38c7 0 12.69-5.47 12.96-12.46l2.38-61.85.17-1.04c.03-.22-.07-.41-.1-.63l4.16-108.17a12.85 12.85 0 0 0-3.61-9.49 13.02 13.02 0 0 0-10.52-3.92L624.6 109.87a13 13 0 0 0-11.78 13.28l4.1 146.05c.2 6.86 5.72 12.4 12.58 12.6l120.63 3.53c.1.02.15.1.24.1Zm31.48-55.64c9.6 1.87 37.05 5.14 62.46-12.09-4.03 16.07-20.57 59.36-82.36 62.8 10.37-6.47 23.75-20.77 19.9-50.7Zm61.05 45.36a8.22 8.22 0 0 1-8.45 7.9l-48.92-1.43c35.42-9.28 51.77-33.48 59.07-50.66l-1.7 44.2Zm-221.23-6.08-3.54-125.83-.57-20.22a8.22 8.22 0 0 1 7.47-8.42l215.53-19.63a8.22 8.22 0 0 1 8.96 8.5l-.92 23.67-3.23 83.87c-29.83 23.02-65.39 13.5-65.74 13.4a2.39 2.39 0 0 0-2.99 2.68c7.16 42.9-21.55 52.29-26.13 53.5l-120.87-3.54a8.22 8.22 0 0 1-7.97-7.98Z",
    style: {
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: ".025px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalyMillionday);
export default __webpack_public_path__ + "static/media/italy_millionday.f0de9116e07f5082cdd91c58b191eac1.svg";
export { ForwardRef as ReactComponent };